module.exports = __webpack_public_path__ + "media/images/home/testimonials/lukas_texl-4a60fd1d9dec6b7a1e59af912274f409.png";